import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import WizCredentialsForm from './WizCredentialsForm';
import WizMappingForm, {assetTypes, wizBucketAssetTypes, legacyAssetTypes, legacyBucketAssetTypes} from './WizMappingForm';
import _ from "lodash";
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils'
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

const WizConfigListing = (props) => {
    const featureFlags = useFeatureFlag();
    const columns = useMemo(()=> [
        {
            title: "Project Name",
            dataIndex: "projectName",
            width: 120,
            render: CellRenderers.VALUE_OR_NA,
        }, {
            title: featureFlags.WIZ_ASSET_TYPE_TREE_SELECT ? "Wiz Issues/Findings" : "Asset Type",
            dataIndex: "assetType",
            width: 120,
            render: value => {
                if(_.isEmpty(value)){
                    return CellRenderers.VALUE_OR_NA();
                }
                // Build label map with Vuln → X for resource types
                const labelMap = {};
                if (featureFlags.WIZ_ASSET_TYPE_TREE_SELECT) {
                  const buildMap = (items, prefix) => {
                      items.forEach(item => {
                          if (!item.children) {
                              labelMap[item.value] = prefix ? `${prefix} → ${item.title}` : item.title;
                          } else if (item.value === 'VULNERABILITY_FINDINGS') {
                              buildMap(item.children, item.title);
                          } else {
                              buildMap(item.children, prefix);
                          }
                      });
                  };
                  buildMap(assetTypes, null);
                  buildMap(wizBucketAssetTypes, null);
                } else {
                  [...legacyAssetTypes, ...legacyBucketAssetTypes].forEach(t => { labelMap[t.value] = t.label; });
                }
                const assetType = value.split(',')
                  .sort((a, b) => {
                    const aV = (labelMap[a] || '').startsWith('Vulnerability');
                    const bV = (labelMap[b] || '').startsWith('Vulnerability');
                    return aV === bV ? 0 : aV ? 1 : -1;
                  })
                  .map(val => labelMap[val] || val).join(', ');       
                return columnRenderArrayData(assetType);
            },
            showFilter:false
        }
    ],[featureFlags])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={WizMappingForm}
            CredentialsForm={WizCredentialsForm}
            extraColumns={columns}
        />
    )
};

export default WizConfigListing;